import request from '@/utils/request';

import { errorNotify } from '@/utils/errorNotification';
import { errorMsg } from '@/utils/message';

/**
 * @typedef {object} Service
 * @property {string} serviceId - サービスのID
 * @property {string} serviceName - サービスの名前（英語）
 * @property {string} serviceNameJa - サービスの名前（日本語）
 */

/**
 * @return {Promise<Service[]>} サービスのIDのリスト
 */
export async function getServiceList() {
  let res_devList = [];
  try {
    const res = await request({
      url: '/servicemasters',
      method: 'get',
    });
    res_devList = res;
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res_devList;
}
